import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import QRCode from "react-qr-code";

export default function ProductModal({ show, setShow, data }) {
  const [isOpen, setIsOpen] = useState(show);

  console.log("in product modal ", show, data);

  function closeModal() {
    setIsOpen(false);
    setShow(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-60" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-3xl mt-5 transform overflow-hidden rounded-xl bg-white text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="poptext_p  text-center  leading-6 text-gray-900"
                  >
                    Product Name : {data.name}
                  </Dialog.Title>
                  <div className=" mx-auto">
                    <div className="md:flex items-center justify-center py-3 2xl:px-20 md:px-6 px-4">
                      <div className="xl:w-2/6 lg:w-2/5 w-40 md:block hidden border p-3">
                        {data?.images?.map((each) => (
                          <img
                            className="w-full"
                            alt={each}
                            src={each}
                          />
                        ))}
                      </div>

                      <div className="xl:w-2/5 md:w-1/2 lg:ml-8 w-60 md:ml-6 md:mt-0 ">
                        <div className="border-b border-gray-200 ">
                          <p className="text-sm leading-none text-gray-600 text-capitalize">
                            {data.brand_name}
                          </p>
                          <h1 className="text-xl font-semibold lg:leading-6 text-capitalize leading-7 text-gray-800 mt-2 pb-3">
                            {data.name}
                          </h1>
                        </div>
                        <div>
                          <p className=" text-sm lg:leading-tight leading-normal text-gray-600  mt-2">
                            <b> Description : </b>{data.description}
                          </p>
                          <p className="text-sm leading-4 mt-2 text-gray-600 ">
                            <b>Category : </b>{data.category_name}
                          </p>
                          <p className="text-sm leading-4 mt-2 text-gray-600 ">
                            <b> Product Code: </b>{data.product_code}
                          </p>
                          <p className="text-sm leading-4 mt-2 text-gray-600 ">
                            <b> Unit : </b>{data.unit_name}
                          </p>

                          <p className="text-sm leading-4 mt-2 text-gray-600 ">
                            <b> Size : </b>{data?.uom_value} {data?.uom_key}
                          </p>
                          {data.distributor_points && (
                            <p className="text-sm leading-4 mt-2 text-gray-600 ">
                              <b> Distributor Points:</b> {data.distributor_points}
                            </p>
                          )}
                          {data.retailer_points && (
                            <p className="text-sm leading-4 mt-2 text-gray-600 ">
                              <b> Retailer Points: </b>{data.retailer_points}
                            </p>
                          )}{data.consumer_points && (
                            <p className="text-sm leading-4 mt-2 text-gray-600 ">
                              <b>
                                Consumer Points:</b> {data.consumer_points}
                            </p>
                          )}

                          <p className="md:w-96 text-sm leading-normal text-gray-600  mt-2">
                            Created At : {data.created_at.slice(0, 10)}
                          </p>
                        </div>
                        {/* <div>
                          <div className="border-t border-b py-4 mt-7 border-gray-200">
                            <div
                              data-menu
                              className="flex justify-between items-center cursor-pointer"
                            >
                              <p className="text-base leading-4 text-gray-800 ">
                                Shipping and returns
                              </p>
                              <button
                                className="cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 rounded"
                                role="button"
                                aria-label="show or hide"
                              >
                                <svg
                                  className="transform text-gray-300 dark:text-white"
                                  width="10"
                                  height="6"
                                  viewBox="0 0 10 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 1L5 5L1 1"
                                    stroke="currentColor"
                                    stroke-width="1.25"
                                    strokeWidth="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>
                            <div
                              className="hidden pt-4 text-base leading-normal pr-12 mt-4 text-gray-600 "
                              id="sect"
                            >
                              You will be responsible for paying for your own
                              shipping costs for returning your item. Shipping
                              costs are nonrefundable
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="border-b py-4 border-gray-200">
                            <div
                              data-menu
                              className="flex justify-between items-center cursor-pointer"
                            >
                              <p className="text-base leading-4 text-gray-800 ">
                                Contact us
                              </p>
                              <button
                                className="cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 rounded"
                                role="button"
                                aria-label="show or hide"
                              >
                                <svg
                                  className="transform text-gray-300 dark:text-white"
                                  width="10"
                                  height="6"
                                  viewBox="0 0 10 6"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 1L5 5L1 1"
                                    stroke="currentColor"
                                    stroke-width="1.25"
                                    strokeWidth="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>
                            <div
                              className="hidden pt-4 text-base leading-normal pr-12 mt-4 text-gray-600 "
                              id="sect"
                            >
                              If you have any questions on how to return your
                              item to us, contact us.
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="text-center closebx">
                    <button
                      type="button"
                      className="flex justify-center items-center w-5 h-5"
                      onClick={closeModal}
                    >
                      x
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
